<template>
  <div class="fund_Info">
    <div class="box1">
      <div class="box1_left">
        <div class="box1_left_top">
          <div class="box1_left_top_text1">{{detail.ths_fund_short_name_fund}}</div>
          <div class="box1_left_top_text2">{{detail.code}}</div>
          <div class="box1_left_top_text3" v-for="(item,index) in detail.tags" :key="'1'+index">{{item}}</div>
          <!-- <div class="box1_left_top_text4">证券11</div> -->
          <div class="box1_left_top_text5">（{{detail.ths_nv_date_fund}}） 交易状态:交易中</div>
        </div>
        <div class="box1_left_bottom">
          <div class="box1_left_bottom_left">
            <div class="box1_left_bottom_left_text1">
              <i style="font-style: normal;" :class="{'colorGreen':detail.ths_unit_nvg_rate_fund && detail.ths_unit_nvg_rate_fund < 0,'colorRed':detail.ths_unit_nvg_rate_fund && detail.ths_unit_nvg_rate_fund > 0}">{{detail.ths_unit_nvg_rate_fund || '--'}}</i>
              <i style="font-style: normal;font-size: 18px;color: #999;margin-left: 12px;">日涨跌幅</i></div>
            <div class="box1_left_bottom_left_text2">
              近一年涨跌幅
              <i style="font-style: normal;" :class="{'colorGreen':detail.ths_yeild_1y_fund && detail.ths_yeild_1y_fund < 0,'colorRed':detail.ths_yeild_1y_fund && detail.ths_yeild_1y_fund > 0}">{{detail.ths_yeild_1y_fund}}%
                </i><i style="font-style: normal; margin-left: 18px">净值{{detail.ths_unit_nv_fund}}</i>
            </div>
          </div>
          <div class="box1_left_bottom_right">
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">
                基金类型：混合型-灵活 | 中高风险
              </div>
              <div class="box1_left_bottom_right_text1">
                成立日期：{{archives.ths_fund_establishment_date_fund}}
              </div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">基金规模：{{archives.ths_fund_scale_fund || '--'}}亿元</div>
              <div class="box1_left_bottom_right_text1">基金经理：{{archives.ths_name_fund || '--'}}</div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">股票仓位：{{archives.ths_stock_mv_to_fanv_fund || '--'}} <i v-if="archives.ths_stock_mv_to_fanv_fund">%</i></div>
              <div class="box1_left_bottom_right_text1">最大回撤：{{archives.ths_max_retrace_rate_fund || '--'}} <i v-if="archives.ths_max_retrace_rate_fund">%</i></div>
            </div>
            <div class="box1_left_bottom_right_group1">
              <div class="box1_left_bottom_right_text1">年化收益：{{archives.ths_annual_adjustment_nvg_ratio_fund || '--'}}%</div>
              <div class="box1_left_bottom_right_text1">
                晨星评级：
                <img src="../../../public/img/fund_Info/start.png" v-if="archives.ths_shs_rating_3y_fund >= 1"/>
                <img src="../../../public/img/fund_Info/start.png" v-if="archives.ths_shs_rating_3y_fund >= 2"/>
                <img src="../../../public/img/fund_Info/start.png" v-if="archives.ths_shs_rating_3y_fund >= 3"/>
                <img src="../../../public/img/fund_Info/start.png" v-if="archives.ths_shs_rating_3y_fund >= 4"/>
                <img src="../../../public/img/fund_Info/start.png" v-if="archives.ths_shs_rating_3y_fund >= 5"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box1_right">
        <div class="box1_right_top">
          <img
            style="
              width: 12px;
              height: 12px;
              vertical-align: middle;
              margin-right: 2px;
            "
            src="../../../public/img/shares_Info/add.png"
            alt=""
          />添加自选
        </div>
        <div class="box1_right_bottom">
          <div class="box1_right_bottom_left">
            <img
              style="
                width: 14px;
                height: 14px;
                vertical-align: middle;
                margin-right: 2px;
              "
              src="../../../public/img/shares_Info/contrast.png"
              alt=""
            />基金对比
          </div>
          <div class="box1_right_bottom_right">公司简介</div>
        </div>
      </div>
    </div>

    <div class="box3">
      <div class="box3_top">
        <div class="box3_text1">
          基金亮点（2条）<img
            src="../../../public/img/shares_Info/vip.png"
            alt=""
          />
        </div>
        <div class="box3_text2" @click="box3_show = true">
          点击展开<img
            src="../../../public/img/shares_Info/xiala_bottom.png"
            alt=""
          />
        </div>
      </div>
      <div class="box3_content" v-if="box3_show">
        <div class="box3_content_options1 margin_top18" v-for="(item,index) in light_spot" :key="'3'+index">
          <div class="box3_content_options1_text1">{{item.tit}}</div>
          <div class="box3_content_options1_text2">
            {{item.txt}}
          </div>
        </div>
        
      </div>
    </div>

    <div class="box4">
      <div class="box4_top">
        <div class="box4_text1">
          基金风险(2条)
          <img src="../../../public/img/shares_Info/vip.png" alt="" />
        </div>
        <div class="box4_text2" @click="box4_show = true">
          点击展开
          <img src="../../../public/img/shares_Info/xiala_bottom.png" alt="" />
        </div>
      </div>
      <div class="box4_content" v-if="box4_show">
        <div class="box4_content_options1 margin_top18" v-for="(item,index) in risk" :key="'4'+index">
          <div class="box4_content_options1_text1">{{item.tit}}</div>
          <div class="box4_content_options1_text2">
            {{item.txt}}
          </div>
        </div>
      </div>
    </div>

    <div class="box5">
      <div class="box5_top_button">
        <div class="box5_top_button_option1">
          <div
            class="box5_top_button_text1"
            :class="{ box5_top_button_text2: bxjj_navigation2 == 0 }"
            @click="change_top_button2(0)"
          >
            收益走势
          </div>
          <div
            class="box5_top_button_text1"
            :class="{ box5_top_button_text2: bxjj_navigation2 == 1 }"
            @click="change_top_button2(1)"
          >
            实时估值
          </div>
        </div>
      </div>
      <div class="box5_top_button" style="margin-bottom: 25px">
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 0 }"
          @click="change_top_button(0)"
        >
          近一月
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 1 }"
          @click="change_top_button(1)"
        >
          近3月
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 2 }"
          @click="change_top_button(2)"
        >
          近6月
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 3 }"
          @click="change_top_button(3)"
        >
          近1年
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 4 }"
          @click="change_top_button(4)"
        >
          近3年
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation == 5 }"
          @click="change_top_button(5)"
        >
          成立以来
        </div>
      </div>
      <div class="box5_top_legend_box">
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option2_colordiv"></div>
          本基金
        </div>
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option3_colordiv"></div>
          沪深300
        </div>
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option1_colordiv"></div>
          同类均值
        </div>
      </div>
      <Chart1></Chart1>
    </div>
    <div class="box6">
      <div class="box5_top_button">
        <div class="box5_top_button_option1">
          <div
            class="box5_top_button_text1"
            :class="{ box5_top_button_text2: bxjj_navigation3 == 0 }"
            @click="change_top_button3(0)"
          >
            业绩排名
          </div>
          <div
            class="box5_top_button_text1"
            :class="{ box5_top_button_text2: bxjj_navigation3 == 1 }"
            @click="change_top_button3(1)"
          >
            历史净值
          </div>
        </div>
      </div>
      <Table></Table>
    </div>
    <div class="box7">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">收益走势</div>
        </div>
      </div>
      <div class="box5_top_button" style="margin-bottom: 25px">
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation4 == 0 }"
          @click="change_top_button4(0)"
        >
          近1年
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation4 == 1 }"
          @click="change_top_button4(1)"
        >
          近3年
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation4 == 2 }"
          @click="change_top_button4(2)"
        >
          近5年
        </div>
      </div>
      <Table2></Table2>
    </div>

    <div class="box8">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">基金经理</div>
        </div>
      </div>
      <div class="box8_content">
        <div class="box8_content_left">
          <div class="box8_content_left_img">
            <img
              src="../../../public/img/fund_Info/1.png"
              alt=""
              style="width: 96px; height: 96px"
            />
          </div>
          <div class="box8_content_left_right">
            <div class="box8_content_left_right_top">
              <i style="font-size: 18px; color: #333333">谢志宇</i>
              <img
                src="../../../public/img/fund_Info/xiala_right.png"
                alt=""
                style="
                  width: 8px;
                  height: 12px;
                  line-height: 24px;
                  margin-left: 6px;
                "
              />
              <i style="font-size: 14px; color: #999999; margin-left: 12px"
                >王帅综合评分: <i style="color: #fcad2a">4.23</i> |
                从业时间:6年210天</i
              >
            </div>
            <div class="box8_content_left_right_center">
              本基金任期 3年83天，任期回报 <i style="font-style:normal;color:#fd4c4c;">+721.55%</i>
            </div>
            <div class="box8_content_left_right_bottom">
              <div class="box8_content_left_right_bottom_box1">
                <div class="box8_content_left_right_bottom_text1">从业年均回报</div>
                <div class="box8_content_left_right_bottom_text2">5.62%</div>
              </div>
              <div class="box8_content_left_right_bottom_box2">
                <div class="box8_content_left_right_bottom_text1">最大盈利 <img src="../../../public/img/shares_Info/yiwen_yellow.png" alt="" style="width:16px;height:16px;vertical-align: -2px;"></div>
                <div class="box8_content_left_right_bottom_text2">205.09%</div>
              </div>
              <div class="box8_content_left_right_bottom_box3">
                <div class="box8_content_left_right_bottom_text1">最大回撤 <img src="../../../public/img/shares_Info/yiwen_yellow.png" alt="" style="width:16px;height:16px;vertical-align: -2px;"></div>
                <div class="box8_content_left_right_bottom_text2 color_green">-33.68%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box8_content_right">
          <div class="box5_top_legend_box" style="margin-left:40px;">
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option2_colordiv"></div>
              任期收益
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option3_colordiv"></div>
              同类回报
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option1_colordiv"></div>
              沪深300
            </div>
          </div>
          <Chart2></Chart2>
        </div>
      </div>
    </div>

    <div class="box9">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">年度回报</div>
          <div class="box9_top_title_text2">
            切换对比<img
              style="width: 9px; vertical-align: middle; margin-left: 3px"
              src="../../../public/img/shares_Info/qiehuan.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="box5_top_legend_box">
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option2_colordiv"></div>
          本基金
        </div>
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option3_colordiv"></div>
          沪深300
        </div>
      </div>
      <Chart3></Chart3>
    </div>

    <div class="box10">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">资产配置</div>
        </div>
      </div>
      <div class="box10_content">
        <Chart4></Chart4>
        <div class="box10_content_right">
          <div class="box5_top_legend_box" style="margin-left:40px;">
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option2_colordiv"></div>
              股票
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option3_colordiv"></div>
              债券
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option1_colordiv"></div>
              现金
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option5_colordiv"></div>
              其他
            </div>
          </div>
          <Chart5></Chart5>
        </div>
      </div>
    </div>

    <div class="box11">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">年度回报</div>
          <div class="box9_top_title_text2">
            2021三季报<img
              style="width: 9px; vertical-align: middle; margin-left: 3px"
              src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="box5_top_button" style="margin-bottom: 25px">
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation5 == 0 }"
          @click="change_top_button5(0)"
        >
          股票行业
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation5 == 1 }"
          @click="change_top_button5(1)"
        >
          债券券种
        </div>
      </div>
      <Table3></Table3>
    </div>

    <div class="box12">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">重仓持股</div>
          <div class="box9_top_title_text2">
            2021三季报<img
              style="width: 9px; vertical-align: middle; margin-left: 3px"
              src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
              alt=""
            />
          </div>
          <div style="position: absolute;right:0;color:#999999;font-size:12px;line-height:24px;">数据更新至 2021-12-31</div>
        </div>
      </div>
      <Table4></Table4>
    </div>

    <div class="box13">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">重仓持债</div>
          <div class="box9_top_title_text2">
            2021三季报<img
              style="width: 9px; vertical-align: middle; margin-left: 3px"
              src="../../../public/img/shares_Info/xiala_bottom_yellow.png"
              alt=""
            />
          </div>
          <div style="position: absolute;right:0;color:#999999;font-size:12px;line-height:24px;">数据更新至 2021-12-31</div>
        </div>
      </div>
      <Table5></Table5>
    </div>

    <div class="box14">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">动态回撤</div>
          <div class="box9_top_title_text2">
            切换基准<img
              style="width: 9px; vertical-align: middle; margin-left: 3px"
              src="../../../public/img/shares_Info/qiehuan.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="box5_top_button" style="margin-bottom: 25px">
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation6 == 0 }"
          @click="change_top_button6(0)"
        >
          近1月
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation6 == 1 }"
          @click="change_top_button6(1)"
        >
          近3月
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation6 == 2 }"
          @click="change_top_button6(2)"
        >
          近6月
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation6 == 3 }"
          @click="change_top_button6(3)"
        >
          近1年
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation6 == 4 }"
          @click="change_top_button6(4)"
        >
          近3年
        </div>
        <div
          class="box5_top_button_button1"
          :class="{ box5_top_button_button2: bxjj_navigation6 == 5 }"
          @click="change_top_button6(5)"
        >
          成立以来
        </div>
      </div>
      <div class="box5_top_legend_box" style="margin-left:0px;">
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option2_colordiv"></div>
          本基金
        </div>
        <div class="box5_top_legend_box_option1">
          <div class="box5_top_legend_box_option3_colordiv"></div>
          沪深300
        </div>
      </div>
      <Chart6></Chart6>
    </div>

    <div class="box15">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">获奖记录</div>
        </div>
      </div>
      <Table6></Table6>
    </div>

    <div class="box16">
      <div class="box5_top_button" style="margin-bottom: 20px">
        <div class="box5_top_button_option1">
          <div class="box5_top_button_text3">持有人结构</div>
        </div>
      </div>
      <div class="box10_content">
        <Chart7></Chart7>
        <div class="box10_content_right" style="margin-left:220px;">
          <div class="box5_top_legend_box" style="margin-left:40px;">
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option2_colordiv"></div>
              机构
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option3_colordiv"></div>
              个人
            </div>
            <div class="box5_top_legend_box_option1">
              <div class="box5_top_legend_box_option1_colordiv"></div>
              内部员工
            </div>
          </div>
          <Chart8></Chart8>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {funddetail,detailPortfolioStock} from '../../http/fund.js'
import Chart1 from "./chart/chart1.vue";
import Chart2 from "./chart/chart2.vue";
import Chart3 from "./chart/chart3.vue";
import Chart4 from "./chart/chart4.vue";
import Chart5 from "./chart/chart5.vue";
import Chart6 from "./chart/chart6.vue";
import Chart7 from "./chart/chart7.vue";
import Chart8 from "./chart/chart8.vue";
import Table from "./table/table1.vue";
import Table2 from "./table/table2.vue";
import Table3 from "./table/table3.vue";
import Table4 from "./table/table4.vue";
import Table5 from "./table/table5.vue";
import Table6 from "./table/table6.vue";
export default {
  data() {
    return {
      box3_show: false,
      box4_show: false,
      bxjj_navigation: 0,
      bxjj_navigation2: 0,
      bxjj_navigation3: 0,
      bxjj_navigation4: 0,
      bxjj_navigation5: 0,
      bxjj_navigation6: 0,
      codes:'',
      detail:{},   //基金基本信息
      archives:{},   //基金档案
      light_spot:[], // 基金亮点
      risk:[],     //基金风险
    };
  },
  methods: {
    initdetailPortfolioStock(){
      let codes = this.codes
      detailPortfolioStock()
    },
    change_top_button(e) {
      this.bxjj_navigation = e;
    },
    change_top_button2(e) {
      this.bxjj_navigation2 = e;
    },
    change_top_button3(e) {
      this.bxjj_navigation3 = e;
    },
    change_top_button4(e) {
      this.bxjj_navigation4 = e;
    },
    change_top_button5(e) {
      this.bxjj_navigation5 = e;
    },
    change_top_button6(e) {
      this.bxjj_navigation6 = e;
    },
    initfund(){
      let codes = this.codes
      funddetail({codes}).then((res)=>{
        console.log(res);
        this.detail = res.data.detail
        this.archives = res.data.archives
        this.risk = res.data.risk.fund
        this.light_spot = res.data.light_spot.fund
      }).catch((err)=>{
        console.log(err);
      })
    }
  },
  components: {
    Chart1,
    Chart2,
    Chart3,
    Chart4,
    Chart5,
    Chart6,
    Chart7,
    Chart8,
    Table,
    Table2,
    Table3,
    Table4,
    Table5,
    Table6,
  },
  mounted(){
    let codes = this.$route.params.codes
    let codes2 = codes.slice(0,2)
    let codes3 = codes.slice(2,8)
    let canshu2 = `${codes3}.${codes2}`
    this.codes = canshu2

    this.initfund()
  }
};
</script>

<style scoped>
i {
  font-style: normal;
}
.fund_Info {
  margin-bottom: 50px;
}
.box1 {
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.box1_left {
  display: flex;
  flex-direction: column;
}
.box1_left_top {
  display: flex;
  align-content: center;
  line-height: 24px;
}
.box1_left_top_text1 {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
}
.box1_left_top_text2 {
  font-size: 18px;
  color: #000000;
  margin-left: 10px;
}
.box1_left_top_text3 {
  width: 64px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text4 {
  width: 54px;
  height: 20px;
  line-height: 20px;
  margin-top: 3px;
  text-align: center;
  background-color: #fcad2a;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
  margin-left: 18px;
}
.box1_left_top_text5 {
  font-size: 12px;
  margin-left: 20px;
  color: #000000;
}
.box1_left_bottom {
  display: flex;
  margin-top: 18px;
}
.box1_left_bottom_left {
  display: flex;
  flex-direction: column;
  padding-right: 24px;
  border-right: 1px solid #ebebeb;
}
.box1_left_bottom_left_text1 {
  font-size: 30px;
}
.box1_left_bottom_left_text2 {
  color: #333333;
  font-size: 18px;
  margin-top: 5px;
}
.box1_left_bottom_right {
  margin-left: 30px;
  display: flex;
}
.box1_left_bottom_right_group1 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 30px;
  color: #333;
}
.box1_right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding-left: 60px;
}
.box1_right_top {
  width: 176px;
  height: 30px;
  background-color: #fcad2a;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  cursor: pointer;
}
.box1_right_bottom {
  display: flex;
  margin-top: 12px;
}
.box1_right_bottom_left {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  cursor: pointer;
}
.box1_right_bottom_right {
  width: 84px;
  height: 30px;
  border-radius: 6px;
  border: solid 1px #fcad2a;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
  color: #fcad2a;
  margin-left: 6px;
  cursor: pointer;
}
.box1_left_bottom_right_text1 img {
  width: 16px;
  height: 15px;
  margin-right: 6px;
  vertical-align: -1px;
}
.box3 {
  width: calc(100% - 48px);
  padding: 0px 24px;
  border-radius: 3px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 24px;
}
.box3_top {
  display: flex;
  justify-content: space-between;
}
.box3_text1 {
  font-size: 18px;
  line-height: 82px;
  color: #333333;
  font-weight: bold;
}
.box3_text1 img {
  width: 48px;
  /* height: 19px; */
  vertical-align: middle;
  margin-left: 10px;
}
.box3_text2 {
  font-size: 16px;
  line-height: 82px;
  color: #666666;
  cursor: pointer;
}
.box3_text2 img {
  width: 17px;
  vertical-align: middle;
  margin-left: 5px;
}
.box3_content {
  margin-bottom: 35px;
}
.box3_content_options1 {
  display: flex;
}
.box3_content_options1:nth-child(1){
  margin-top: 0;
}
.box3_content_options1_text1 {
  width: 72px;
  height: 30px;
  background-color: rgba(253, 76, 76, 0.06);
  border-radius: 6px;
  font-size: 16px;
  line-height: 30px;
  color: #fd4c4c;
  text-align: center;
}
.box3_content_options1_text2 {
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  margin-left: 12px;
}
.box4 {
  width: calc(100% - 48px);
  padding: 0px 24px;
  border-radius: 3px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 24px;
}
.box4_top {
  display: flex;
  justify-content: space-between;
}
.box4_text1 {
  font-size: 18px;
  line-height: 82px;
  color: #333333;
  font-weight: bold;
}
.box4_text1 img {
  width: 48px;
  vertical-align: middle;
  margin-left: 10px;
}
.box4_text2 {
  font-size: 16px;
  line-height: 82px;
  color: #666666;
  cursor: pointer;
}
.box4_text2 img {
  width: 17px;
  vertical-align: middle;
  margin-left: 5px;
}
.box4_content {
  margin-bottom: 35px;
}

.box4_content_options1 {
  display: flex;
}
.box4_content_options1:nth-child(1){
  margin-top: 0;
}
.box4_content_options1_text1 {
  width: 72px;
  height: 30px;
  background-color: rgba(83, 156, 255, 0.06);
  border-radius: 6px;
  font-size: 16px;
  line-height: 30px;
  color: #539cff;
  text-align: center;
}
.box4_content_options1_text2 {
  font-size: 16px;
  line-height: 30px;
  color: #333333;
  margin-left: 12px;
}
.box5 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box5_top_button_option1 {
  display: flex;
  
  
}
.box5_top_button_text1 {
  font-size: 18px;
  color: #666666;
  cursor: pointer;
}
.box5_top_button_text1:nth-child(2) {
  margin-left: 24px;
}
.box5_top_button_text2 {
  color: #000000;
  font-weight: bold;
  position: relative;
}
.box5_top_button_text2::after {
  content: " ";
  display: block;
  width: 36px;
  height: 3px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -6px;
  left: calc(50% - 18px);
}
.box5_top_button {
  display: flex;
  align-content: center;
  margin-bottom: 30px;
  position: relative;
}
.box5_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box5_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box5_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box5_top_legend_box {
  display: flex;
  margin-bottom: 20px;
}
.box5_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box5_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box5_top_legend_box_option2 {
  display: flex;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box5_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.box5_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box5_top_legend_box_option3_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box5_top_legend_box_option4_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box5_top_legend_box_option5_colordiv {
  background-color: #e7e7e7;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}

.margin_top18 {
  margin-top: 18px;
}
.i1 {
  font-style: normal;
  color: #fd4c4c;
}
.box6 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box7 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box5_top_button_text3 {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.box8 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box8_content_left {
  width: 500px;
  height: 125px;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0px 6px 41px 5px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  display: flex;
}
.box8_content_left_img {
  line-height: 125px;
}
.box8_content_left_img img {
  vertical-align: middle;
}
.box8_content_left_right_top {
  line-height: 24px;
  margin-left: 20px;
}
.box8_content_left_right_center {
  font-size: 14px;
  color: #333333;
  width: 299px;
	height: 32px;
  line-height: 32px;
	background-color: #f8f9fd;
	border-radius: 16px;
  text-align: center;
  margin-top: 13px;
  margin-left: 20px;
}
.box8_content_left_right_bottom{
  display: flex;
  margin-left: 20px;
  margin-top: 13px;
}
.box8_content_left_right_bottom_box1{
  padding-right: 15px;
  border-right: solid 1px #e9ebf3;
}
.box8_content_left_right_bottom_box2{
  padding-right: 10px;
  margin-left: 15px;
  border-right: solid 1px #e9ebf3;
}
.box8_content_left_right_bottom_box3{
  margin-left: 15px;
}
.box8_content_left_right_bottom_text1{
  font-size: 14px;
	color: #333333;
}
.box8_content_left_right_bottom_text2{
  font-size: 20px;
	color: #fd4c4c;
  
}
.box8_content{
  display: flex;
}
.box8_content_right{
  margin-left: 80px;
}
.box9 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box9_top_title_text2 {
  width: 84px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(252, 173, 42, 0.06);
  border-radius: 3px;
  font-size: 12px;
  color: #fcad2a;
  margin-left: 12px;
  cursor: pointer;
}
.box10 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box10_content{
  display: flex;
}
.box10_content_right{
  margin-left: 150px;
}
.box11 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box12 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box13 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box14 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box15 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}
.box16 {
  width: calc(100% - 48px);
  background-color: #ffffff;
  border-radius: 6px;
  margin-top: 24px;
  padding: 24px;
}


.color_green{
  color: #3cbb73;
}
.colorRed {
  color: #fd4c4c !important;
}
.colorBlue {
  color: #4372ba !important;
}
.colorGreen {
  color: #41b357 !important;
}
.colorYellow{
    color: #fcad2a !important;
}
</style>